import { defineMessages } from "react-intl";

export default defineMessages({
  cantFindTheAnswerToYourQuestion: {
    id: "customerSupport.cantFindTheAnswerToYourQuestion",
    defaultMessage: "Can't find the answer to your question?",
  },
  contactUsViaOurPhoneOrEmail: {
    id: "customerSupport.contactUsViaOurPhoneOrEmail",
    defaultMessage: "Contact us via phone on {phone} or email on {email}",
  },
  contactUsPhoneNumber: {
    id: "customerSupport.contactUsPhoneNumber",
    defaultMessage: "02 646 81 17",
  },
});
